<template>
<div class="scrollpage-container">
	
    <div v-if="pullReload" class="spinner" :style="calculateSpinnerStyle">
      <spinner/>
    </div>
  <div ref="ptr" class="content" :class='{"do-transition" : easeToEnd}' :style="calculateTranslate">
   
    <slot></slot>
    <div class="fill-remaining-height"></div>
  </div>
  <!--
  <div class="scrollbar">
    <div ref="scroll-button" class="button">
      <div class="button-height">
      </div>
    </div>
  </div>
  -->
</div>
</template>

<script>
import Spinner from '../components/Spinner.vue';
import { eventBus } from '../services/EventBus.js';


export default {
  name: 'scroll-page',
  props:{
  pullReload:{ // pull to reload
    type:Boolean,
    default:false
    }
  },
  data:function(){
    return {
      yStart:0,
      xStart:0,
      yMoved:0,
      percentage:0,
      refreshing:false,
      swipingDirection:undefined,
      scrollTop:0,
      canStartPull:true,
      pulling:false,
      atTop:true,
      atBottom:false,
      easeToEnd:false,
    }
  },
  computed:{
    calculateTranslate(){
       // eslint-disable-next-line
      if(this.refreshing){ this.percentage=1}
       // eslint-disable-next-line
      if(this.easeToEnd){ this.percentage=0}

      var dist=50*this.percentage;

      return {transform:"translateY("+dist+"px)"}
    },
    calculateSpinnerStyle(){
      return {opacity:1*this.percentage,transform:"scale("+(1*this.percentage)+")"}
    }
  },
  components:{
    Spinner,
  },
  methods:{
  ts(e){
      

      if(this.refreshing || !e.changedTouches){return;}
      this.yStart=e.changedTouches[0].clientY;
      this.xStart=e.changedTouches[0].clientX;
      
      if(this.scrollTop<=0){
        this.canStartPull=true;
       this.easeToEnd=false;
       // this.capturedTopY=Math.abs(this.scrollTop);
      }
     
    },
    te(e){
      
      this.canStartPull=false;
      
      this.swipingDirection=undefined;
      if(this.refreshing || !e.changedTouches){return;}
      

      if(this.pulling){
       
        if(this.percentage<1){
          this.waitAnimateEnd();
        }else{
          //this.capturedTopY=50;
          //this.calculatePercentage();
          this.waitBeforeRefresh();
        }
      }

      if(this.pulling){
        //this.preventAll(e);
        this.pulling=false;
      }

    },
    tm(e){

      if( this.refreshing || !e.changedTouches){return;}
      var yEnd=e.changedTouches[0].clientY;
      
      

       
      if(this.getSwipingDirection(e)=="H"){
        return;
      }
     
      this.yMoved=this.yStart-yEnd;
         
      if(!this.refreshing && this.canStartPull && this.yMoved<0){
        this.isPulling(e);
       // this.preventAll(e);

      }
      
    
       
    },
    isPulling(){
      this.pulling=true;
      // if pulling then we are not scrolling
      this.calculatePercentage(); 
    },
    calculatePercentage(){
      
      if(!this.canStartPull){
        this.yMoved=0;
      }

     
      var precision=Math.abs(window.innerHeight/4);
      var maxRad=Math.atan2(precision,-precision)-(Math.PI/2);
      var moved=0;
      if(this.scrollTop<=0){
        moved=this.scrollTop+this.yMoved;
       
      }
      var rad=Math.atan2(precision,moved)-(Math.PI/2);
      this.percentage=rad/maxRad;

      if(this.percentage>=1){
        this.percentage=1;
      }
      

    },
    preventAll(e){
      // stop swinging the page apple...
      if (e.cancelable) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      
        
    },
    getSwipingDirection(e){
      if(this.swipingDirection!=undefined){return this.swipingDirection;}
      var yEnd=e.changedTouches[0].clientY;
      this.yMoved=this.yStart-yEnd;
      var xEnd=e.changedTouches[0].clientX;
      var xMoved=this.xStart-xEnd;
      
      if(Math.abs(xMoved)>5){
        this.swipingDirection="H";
      }
      if(Math.abs(this.yMoved)>5){
        this.swipingDirection="V";
      }
    },
    waitBeforeRefresh(){
      
      this.refreshing=true;
      setTimeout(()=>{
          this.doRefresh();
        },800)
    },
    doRefresh(){
      // emit refresh...
      eventBus.$emit("RELOAD_FROM_PULL")
     
    },
    stopLoadFromEvent(){
      this.refreshing=false;
      this.easeToEnd=false;
    },
    startLoadFromEvent(){
      this.refreshing=true;
      this.percentage=1;
    },
    endLoadFromEvent(){
      
      this.waitAnimateEnd();

      // always set page to top if loaded ensures "load more" at bottom works when changing
      // the news sub pages
      this.element.scrollTop=0;
    },
    waitAnimateEnd(){
      //this.percentage=0;
      this.refreshing=true;
      this.easeToEnd=true;
      this.pulling=false;

      setTimeout(()=>{
           this.refreshing=false;
           this.easeToEnd=false;
           // allow css animation to finish
        },350)
    },
    scrolling(){
     
      this.scrollTop=this.element.scrollTop;
      this.calculatePercentage();

      if(this.scrollTop>0){
        this.canStartPull=false;
      }

      // check top and bottom
      var scrollheight=this.element.scrollHeight;
      var height=this.element.offsetHeight

      var scrollTop=this.element.scrollTop;
      var scrollBottom=scrollheight-height;

      if(!this.atTop && scrollTop<=0){
         this.atTop=true;
         eventBus.$emit('SCROLL_TOP_REACHED');
      }else{
        this.atTop=false;
      }

      if (!this.atBottom && scrollTop>=scrollBottom-1) {
        // botom reached
        this.atBottom=true;
        console.log("bottom is reached")
        eventBus.$emit('SCROLL_BOTTOM_REACHED');
      }else{
        // release in next tick to give renderer some time
        this.atBottom=false;
         
      }
      
      // emit scroll event
      eventBus.$emit('SCROLL',{element:this.element});
     
     // style scrollbar android
     //this.updateScrollbar();
    },
   addListeners(){
      
     if(this.pullReload){
       this.element.addEventListener('touchstart',this.ts);
        this.element.addEventListener('touchend',this.te);
        this.element.addEventListener('touchmove',this.tm,{passive:false});
     }
     
     this.element.addEventListener('scroll',this.scrolling);
   },
   removeListeners(){
     eventBus.$off("SCROLL_TO_BOTTOM",this.scrollToBottom)
     this.$off("SCROLLPAGE_STOP_LOAD",this.stopLoadFromEvent);
     this.$off("SCROLLPAGE_START_LOAD",this.startLoadFromEvent);
     this.$off("SCROLLPAGE_END_LOAD",this.endLoadFromEvent);
     
     if(this.pullReload){
        this.element.removeEventListener('touchstart',this.ts);
        this.element.removeEventListener('touchend',this.te);
        this.element.removeEventListener('touchmove',this.tm,{passive:false});
     }
     
     this.element.removeEventListener('scroll',this.scrolling);
   },
   /*
   updateScrollbar(){

     // get scrollHeight
     var scrollHeight=this.element.scrollHeight;
     var scrollTop=this.element.scrollTop;

     // get percentage scrolled
     var percentage= (scrollTop/scrollHeight)*100;
     
    
    this.scrollButton.style.transform="translateY("+(percentage)+"%)";
   },
   */
   scrollToBottom(){

     this.element.scrollTop = this.element.scrollHeight+1000;
    
   }
  },
  beforeDestroy(){
   this.removeListeners();
  },
  created(){
   
    // must be earlier to catch all events from mounted children
    eventBus.$on("SCROLL_TO_BOTTOM",this.scrollToBottom)
    this.$on("SCROLLPAGE_STOP_LOAD",this.stopLoadFromEvent);
    this.$on("SCROLLPAGE_START_LOAD",this.startLoadFromEvent);
    this.$on("SCROLLPAGE_END_LOAD",this.endLoadFromEvent);
  },
  mounted(){
    this.element=this.$refs['ptr'];
    this.scrollButton=this.$refs['scroll-button'];

    this.addListeners();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.scrollpage-container{
  position:relative;
  width:100vw;
  flex:1;
}

.content{
  position:absolute;
  top:0;
  left:0;
  height:100%;
  width:100vw;
  transform:translateY(0px);
  overflow:hidden;
  overflow-y:scroll;
  -webkit-overflow-scrolling: touch;
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.spinner{
  position:absolute;
  width:100%;
  text-align:center;
  top:0;
  left:0;
  margin:4px 0px;
}
.do-transition{
  transition:transform .25s;
}

/* makes the scrollable div actual always scroll
on ios also if contetn is too short */
.fill-remaining-height{
  flex:1;
  position:relative;
}

.fill-remaining-height::after{
  content:"";
  position:absolute;
  border:1px solid transparent; /* hacking the container to be slightly larger and forcing momentum scroll */
  width:100%;
  height:100%;

}


.scrollbar{
  display:block;
  position:absolute;
  top:0;
  right:0;
  height:100%;
  width:4px;
  background:transparent;
  margin:0px 2px;
  border:1px solid red;
}

.scrollbar .button{
  display:block;
  position:relative;
  top:0;
  left:0;
  width:100%;
  height:100%;
  transform:translateY(0%);
}

.button-height{
  height:100px;
  background:rgba(0,0,0,.5);
}

</style>